export default __webpack_public_path__ + "static/char-v-55-ja-98cbd9cb200ea9486d1974906764ff01.mp4";